import { render, staticRenderFns } from "./VueCheckboxGroup.vue?vue&type=template&id=b99517ba&"
import script from "./VueCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./VueCheckboxGroup.vue?vue&type=script&lang=js&"
import style0 from "./VueCheckboxGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports